import React from "react";
import {
	Box,
	Link,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from "@mui/material";
import RightArrow from "../../../../assets/svg-fc/RightArrow";
import CalendarBlank from "../../../../assets/svg-fc/CalendarBlank";
import UserBlank from "../../../../assets/svg-fc/UserBlank";
import ForkKnife from "../../../../assets/svg-fc/ForkKnife";
import BuildingsIcon from "../../../../assets/svg-fc/BuildingsIcon";
import ChefIcon from "../../../../assets/svg-fc/ChefIcon";
import MoneyIcon from "../../../../assets/svg-fc/MoneyIcon";
import OccasionSvg from "../../../../assets/svg-fc/OccasionSvg";
import ProfileIcon from "../../../../assets/svg-fc/ProfileIcon";
import { Link as RouterLink } from "react-router-dom";

interface iVendorEventCardProps {
	eventId: string;
	eventName: string;
	location: string;
	serviceType: string;
	providerType: string;
	customerName: string;
	foodTypes: string;
	budget: number;
	guests: number;
	eventDate: string;
	isBudgetFlexible: boolean;
	href: string;
	notificationVendorCardDot?: boolean;
}
const VendorCard = (props: iVendorEventCardProps) => {
	const {
		eventName,
		location,
		foodTypes,
		serviceType,
		providerType,
		guests,
		budget,
		isBudgetFlexible,
		customerName,
		eventDate,
		href,
		notificationVendorCardDot,
	} = props;
	return (
		<>
			<Link
				component={RouterLink}
				to={href}
				className="vendor_card"
			>
				<Box className="card_head">
					<Box component="h1">
						{notificationVendorCardDot && (
							<span className="listChildTextBadge"></span>
						)}
						{eventName}
					</Box>
					<Box
						component="span"
						className="arrow_icon"
					>
						<RightArrow />
					</Box>
				</Box>
				<List className="card_body">
					<ListItem className="list_group">
						<ListItem>
							<ListItemAvatar>
								<CalendarBlank />
							</ListItemAvatar>
							<ListItemText primary={eventDate} />
						</ListItem>
						<ListItem>
							<ListItemAvatar>
								<UserBlank />
							</ListItemAvatar>
							<ListItemText primary={`${guests} Guests`} />
						</ListItem>
					</ListItem>
					<ListItem>
						<ListItemAvatar>
							<MoneyIcon />
						</ListItemAvatar>
						<ListItemText
							primary={`AED ${budget}`}
							secondary={
								isBudgetFlexible && (
									<span className="chipPill">flexible</span>
								)
							}
						/>
					</ListItem>
					{!!foodTypes && (
						<ListItem>
							<ListItemAvatar>
								<ForkKnife />
							</ListItemAvatar>
							<ListItemText primary={foodTypes} />
						</ListItem>
					)}
					<ListItem className="list_group">
						<ListItem>
							<ListItemAvatar>
								<BuildingsIcon />
							</ListItemAvatar>
							<ListItemText primary={location} />
						</ListItem>
						{!!serviceType && (
							<ListItem>
								<ListItemAvatar>
									<OccasionSvg />
								</ListItemAvatar>
								<ListItemText primary={serviceType} />
							</ListItem>
						)}
					</ListItem>
					{!!providerType && (
						<ListItem>
							<ListItemAvatar>
								<ChefIcon />
							</ListItemAvatar>
							<ListItemText primary={providerType} />
						</ListItem>
					)}

					<ListItem>
						<ListItemAvatar>
							<ProfileIcon />
						</ListItemAvatar>
						<ListItemText primary={`Created By ${customerName}`} />
					</ListItem>
				</List>
			</Link>
		</>
	);
};
export default VendorCard;
